import verifyEmailModule from "../verifyEmailModule"


function verifyEmailContainer(verifyEmailResources) {
    "ngInject";

    return {
        restrict: "A",
        replace: false,
        templateUrl: verifyEmailResources.templates.verifyEmailContainer,
    }
}
verifyEmailModule.directive("verifyEmailContainer", verifyEmailContainer);

export default verifyEmailModule;